export default "__VITE_ASSET__Kyhq4D2$__"